// extracted by mini-css-extract-plugin
export var active = "lightSelector-module--active--SDF2b";
export var icon = "lightSelector-module--icon--0Vck7";
export var iconContainer = "lightSelector-module--iconContainer--KWulL";
export var iconText = "lightSelector-module--iconText--jkEhr";
export var icons = "lightSelector-module--icons--4BDcj";